// extracted by mini-css-extract-plugin
export const root = "s_r";
export const paper = "s_s";
export const title = "s_x";
export const btnStatus = "s_Z";
export const titleRoot = "s_0";
export const titleSection = "s_S";
export const deleteBtn = "s_V";
export const sectionTitle = "s_1";
export const btnPreview = "s_2";
export const createdTxt = "s_3";
export const subTitleRoot = "s_4";
export const statusRoot = "s_5";
export const statsRoot = "s_6";
export const leafletRoot = "s_7";
export const shopRoot = "s_8";
export const btnMore = "s_9";
export const pauseState = "s_bb";
export const notFoundRoot = "s_bc";
export const input = "s_g";
export const showOnNonPhone = "s_bd";
export const showOnPhone = "s_bf";